import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { ScrollContext } from "react-router-scroll-4";
import AuthHOC from "./utils/AuthHOC";
import usePaymentCheck from "./utils/payment";
import { IntlReducer as Intl, IntlProvider } from "react-redux-multilingual";
import "./index.scss";
// Import custom components
import store from "./store";
import {
  product_actions,
  wishlist_actions,
  cart_actions,
  auth_actions,
} from "./redux-store";
import { url_encode } from "./utils";
import translations from "./constants/translations";
import { getAllProducts } from "./actions";
import Landing from "./components/landing";
import { initGA, PageView } from "./components/Tracking/Tracking";
import LandingOld from "./components/LandingOld";
import SmoothScroll from "./containers/SmoothScroll";
import RouteWithLayout from "./containers/RouteWithLayout";
// Layouts
import Fashion from "./components/layouts/fashion/main";
import Vegetables from "./components/layouts/vegetables/main";
import Kids from "./components/layouts/kids/main";
import Pets from "./components/layouts/pets/main";
import Furniture from "./components/layouts/furniture/main";
import Watch from "./components/layouts/watch/main";
import Beauty from "./components/layouts/beauty/main";
import Electronic from "./components/layouts/electronic/main";
//Collection Pages
import CollectionLeftSidebar from "./components/collection/collection-left-sidebar";
import CollectionNoSidebar from "./components/collection/collection-no-sidebar";
import CollectionRightSidebar from "./components/collection/collection-right-sidebar";
import CollectionFullWidth from "./components/collection/collection-full-width";
import CollectionMetro from "./components/collection/collection-metro";
// Product Pages
import LeftSideBar from "./components/products/left-sidebar";
import RightSideBar from "./components/products/right-sidebar";
import NoSideBar from "./components/products/no-sidebar";
import LeftImage from "./components/products/left-image";
import RightImage from "./components/products/right-image";
import Accordian from "./components/products/accordian";
import ColumnLeft from "./components/products/column-left";
import ColumnRight from "./components/products/column-right";
import Column from "./components/products/column";
import Vertical from "./components/products/vertical";
// Features
import Layout from "./components/app";
import Cart from "./components/cart";
import Compare from "./components/compare/index";
import wishList from "./components/wishlist";
import checkOut from "./components/checkout";
import orderSuccess from "./components/checkout/success-page";
// Extra Pages
// import aboutUs from "./components/pages/about-us";
import PageNotFound from "./components/pages/404";
import lookbook from "./components/pages/lookbook";
import Login from "./components/pages/login";
import Register from "./components/pages/register";
import Search from "./components/pages/search";
import Collection from "./components/pages/collection";
import ForgetPasswordMem from "./components/pages/forget-password";
import Contact from "./components/pages/contact";
import Dashboard from "./components/pages/dashboard";
import Faq from "./components/pages/faq";
import AdCard from "./components/pages/AdCard/AdCard";
import ForgetPassword from "./components/pages/ForgetPassword";
import orders from "./components/pages/Dashboard/components/OrdersMer";
// Blog Pages
import RightSide from "./components/blogs/right-sidebar";
import Details from "./components/blogs/details";
import BlogPage from "./components/blogs/blog-page";
// Theme Element
import ElementTitle from "./components/features/theme/element-title";
import ElementBanner from "./components/features/theme/element-banner";
import ElementSlider from "./components/features/theme/element-slider";
import ElementCategory from "./components/features/theme/element-category";
import ElementService from "./components/features/theme/element-service";
import ElementRatio from "./components/features/theme/element-ratio";
// Product Elements
import ElementProductBox from "./components/features/product/element-product-box";
import ElementProductSlider from "./components/features/product/element-product-slider";
import ElementProductNoSlider from "./components/features/product/element-product-no-slider";
import ElementMultipleSlider from "./components/features/product/element-multiple-slider";
import ElementProductTab from "./components/features/product/element-product-tab";
// Portfolio Features
import GridCols from "./components/features/portfolio/grid-cols";
import MasonaryGridCols from "./components/features/portfolio/masonary-grid-cols";
import collectionMetro from "./components/collection/collection-metro";
import OrdersMer from "./components/pages/Dashboard/components/OrdersMer";
import Notifications from "./components/NotifyMerch/Notifications";
import intro from "./components/pages/intro";
import ProductCatalogue from "./components/pages/ProductCatalogue";
import Merchants from "./components/pages/Merchants";
import Available from "./components/pages/Available";
import vacRules from "./components/pages/vac-rules";
import dacRules from "./components/pages/dac-rules";
import ParentConsentForm from "./components/pages/ParentConsentForm";
import GaListener from "./components/Tracking/GaListener";
import ResetPassword from "./components/pages/ResetPassword";
import FillForm from "./components/pages/PCF/FillForm";
import PrivacyPolicy from "./components/pages/PrivacyPolicy/PrivacyPolicy";
import RegisterBrand from "./components/pages/Register/RegisterBrand";
import Termsofuse from "./components/pages/Termsofuse";
import AboutUs from "./components/pages/about-us";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import Retailers from "./components/pages/Retailers";
import PaymentIntegration from "./components/pages/PaymentIntegration";
import VerifyAccount from "./components/pages/VerifyAccount";
import AccountList from "./components/pages/Accounts/AccountList";
import AddAccount from "./components/pages/Accounts/AddAccount";
import ViewAccount from "./components/pages/Accounts/ViewAccount";
import CompleteOnboard from "./components/pages/Accounts/CompleteOnboard";

class Root extends React.Component {
  componentDidMount() {
    setTimeout(() => {
      document.querySelector(".loader-wrapper").style.display = "none";
    }, 1000);
    // store.dispatch(
    //   product_actions.update_filter({
    //     populate: url_encode([
    //       {
    //         path: "product_category",
    //       },
    //       {
    //         path: "merchant_user",
    //         select: "-password",
    //       },
    //     ]),
    //   })
    // );
    store.dispatch(wishlist_actions.init_wishlist_from_local_storage());
    store.dispatch(cart_actions.init_cart_from_local_storage());
    if (sessionStorage.getItem("token"))
      store.dispatch(auth_actions.login_by_token());
  }
  render() {
    store.dispatch(getAllProducts());
    let persistor = persistStore(store);
    return (
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <IntlProvider translations={translations} locale="en">
            <BrowserRouter basename={"/"}>
              <GaListener trackingId="UA-205848017-1">
                <ScrollContext>
                  <Switch>
                    <RouteWithLayout
                      layout={Layout}
                      exact
                      path={`${process.env.PUBLIC_URL}/404`}
                      component={PageNotFound}
                    />
                    {/* <RouteWithLayout
                      layout={Layout}
                      path={`${process.env.PUBLIC_URL}/product-catalogue/:id`}
                      component={ProductCatalogue}
                    /> */}
                    <RouteWithLayout
                      layout={Layout}
                      path={`${process.env.PUBLIC_URL}/product-catalogue/:id`}
                      component={Retailers}
                    />
                    <RouteWithLayout
                      layout={Layout}
                      path={`${process.env.PUBLIC_URL}/payment-integration`}
                      component={PaymentIntegration}
                    />
                    <RouteWithLayout
                      layout={Layout}
                      path={`${process.env.PUBLIC_URL}/account-list`}
                      component={AccountList}
                    />
                    <RouteWithLayout
                      layout={Layout}
                      path={`${process.env.PUBLIC_URL}/onboard-account`}
                      component={AddAccount}
                    />
                    <RouteWithLayout
                      layout={Layout}
                      path={`${process.env.PUBLIC_URL}/add-account/:accountType`}
                      component={AddAccount}
                    />
                    <RouteWithLayout
                      layout={Layout}
                      path={`${process.env.PUBLIC_URL}/complete-onboard/:accountType/:accountId/:id`}
                      component={CompleteOnboard}
                    />
                    <RouteWithLayout
                      layout={Layout}
                      path={`${process.env.PUBLIC_URL}/view-account/:accountType/:accountId/:id`}
                      component={ViewAccount}
                    />
                    <RouteWithLayout
                      layout={Layout}
                      exact
                      path={`${process.env.PUBLIC_URL}/product/my`}
                      component={AuthHOC(CollectionMetro)}
                    />

                    {/* <RouteWithLayout
                      layout={Layout}
                      exact
                      path={`${process.env.PUBLIC_URL}/merchants`}
                      component={Merchants}
                    /> */}
                    <RouteWithLayout
                      layout={Layout}
                      exact
                      path={`${process.env.PUBLIC_URL}/merchants`}
                      component={Retailers}
                    />
                    <RouteWithLayout
                      layout={Layout}
                      path={`${process.env.PUBLIC_URL}/product/:id`}
                      component={AuthHOC(LeftSideBar)}
                    />
                    {/* <RouteWithLayout layout={Layout} path={`${process.env.PUBLIC_URL}/product`} component={CollectionNoSidebar} /> */}
                    {/* <RouteWithLayout  path={`${process.env.PUBLIC_URL}/login/:role`} component={Login} layout={Layout} /> */}
                    <RouteWithLayout
                      path={`${process.env.PUBLIC_URL}/login`}
                      component={Login}
                      layout={Layout}
                    />
                    <RouteWithLayout
                      layout={Layout}
                      exact
                      path={`${process.env.PUBLIC_URL}/register/:role`}
                      component={Register}
                    />
                    <RouteWithLayout
                      layout={Layout}
                      exact
                      path={`${process.env.PUBLIC_URL}/signup/brand`}
                      component={RegisterBrand}
                    />
                    <RouteWithLayout
                      layout={Layout}
                      exact
                      path={`${process.env.PUBLIC_URL}/about-us`}
                      component={AboutUs}
                    />
                    <RouteWithLayout
                      layout={Layout}
                      exact
                      path={`${process.env.PUBLIC_URL}/intro`}
                      component={intro}
                    />
                    <RouteWithLayout
                      layout={Layout}
                      exact
                      path={`${process.env.PUBLIC_URL}/termsofuse`}
                      component={Termsofuse}
                    />
                    <RouteWithLayout
                      layout={Layout}
                      exact
                      path={`${process.env.PUBLIC_URL}/forget-password`}
                      component={ForgetPassword}
                    />
                    <RouteWithLayout
                      layout={Layout}
                      exact
                      path={`${process.env.PUBLIC_URL}/password/reset/:token`}
                      component={ResetPassword}
                    />
                    <RouteWithLayout
                      layout={Layout}
                      exact
                      path={`${process.env.PUBLIC_URL}/privacypolicy`}
                      component={PrivacyPolicy}
                    />
                    <RouteWithLayout
                      layout={Layout}
                      exact
                      path={`${process.env.PUBLIC_URL}/forget-password/member`}
                      component={ForgetPasswordMem}
                    />
                    <RouteWithLayout
                      layout={Layout}
                      exact
                      path={`${process.env.PUBLIC_URL}/availableeac`}
                      component={Available}
                    />
                    <RouteWithLayout
                      layout={Layout}
                      exact
                      path={`${process.env.PUBLIC_URL}/contact`}
                      component={Contact}
                    />
                    <RouteWithLayout
                      layout={Layout}
                      path={`${process.env.PUBLIC_URL}/dashboard/:role`}
                      component={AuthHOC(Dashboard, usePaymentCheck)}
                    />
                    <RouteWithLayout
                      layout={Layout}
                      exact
                      path={`${process.env.PUBLIC_URL}/cart`}
                      component={AuthHOC(Cart)}
                    />
                    <RouteWithLayout
                      layout={Layout}
                      path={`${process.env.PUBLIC_URL}/notification`}
                      component={AuthHOC(Notifications)}
                    />
                    <RouteWithLayout
                      layout={Layout}
                      path={`${process.env.PUBLIC_URL}/checkout`}
                      component={AuthHOC(checkOut)}
                    />
                    {/* <RouteWithLayout layout={Layout} path={`${process.env.PUBLIC_URL}/compare`} component={Compare} /> */}
                    <RouteWithLayout
                      layout={Layout}
                      path={`${process.env.PUBLIC_URL}/checkout`}
                      component={checkOut}
                    />
                    {/* <RouteWithLayout layout={Layout} path={`${process.env.PUBLIC_URL}/merchant/orders`} component={OrdersMer} /> */}
                    <RouteWithLayout
                      layout={Layout}
                      path={`${process.env.PUBLIC_URL}/order-success`}
                      component={AuthHOC(orderSuccess)}
                    />
                    <RouteWithLayout
                      layout={Layout}
                      path={`${process.env.PUBLIC_URL}/order/:order_id`}
                      component={AuthHOC(orderSuccess)}
                    />
                    <RouteWithLayout
                      layout={Layout}
                      exact
                      path={`${process.env.PUBLIC_URL}/shop`}
                      component={AuthHOC(CollectionNoSidebar, usePaymentCheck)}
                    />
                    <RouteWithLayout
                      layout={Layout}
                      exact
                      path={`${process.env.PUBLIC_URL}/faq`}
                      component={Faq}
                    />
                    <RouteWithLayout
                      layout={Layout}
                      exact
                      path={`${process.env.PUBLIC_URL}/consent-form/:id`}
                      component={ParentConsentForm}
                    />
                    <RouteWithLayout
                      layout={Layout}
                      exact
                      path={`${process.env.PUBLIC_URL}/fill/consent-form`}
                      component={FillForm}
                    />
                    <RouteWithLayout
                      exact
                      path={`${process.env.PUBLIC_URL}/`}
                      component={Landing}
                    />
                    <RouteWithLayout
                      layout={Layout}
                      exact
                      path={`${process.env.PUBLIC_URL}/vac-rules`}
                      component={vacRules}
                    />
                    <RouteWithLayout
                      layout={Layout}
                      exact
                      path={`${process.env.PUBLIC_URL}/dac-rules`}
                      component={dacRules}
                    />
                    <RouteWithLayout
                      layout={Layout}
                      exact
                      path={`${process.env.PUBLIC_URL}/adcard/:id`}
                      component={AdCard}
                    />
                    <RouteWithLayout
                      layout={Layout}
                      exact
                      path={`${process.env.PUBLIC_URL}/wishList`}
                      component={wishList}
                    />
                    <RouteWithLayout
                      layout={Layout}
                      exact
                      path={`${process.env.PUBLIC_URL}/verify-account/:account/:token`}
                      component={VerifyAccount}
                    />
                    <Redirect to={`${process.env.PUBLIC_URL}/404`} />
                    {/* <Layout>
                                   
                                    Routes For Features (Product Collection)
                                    <Route path={`${process.env.PUBLIC_URL}/left-sidebar/collection`} component={CollectionLeftSidebar} />
                                    <Route path={`${process.env.PUBLIC_URL}/no-sidebar/collection`} component={CollectionNoSidebar} />
                                    <Route path={`${process.env.PUBLIC_URL}/right-sidebar/collection`} component={CollectionRightSidebar} />
                                    <Route path={`${process.env.PUBLIC_URL}/full-width/collection`} component={CollectionFullWidth} />
                                    <Route path={`${process.env.PUBLIC_URL}/metro/collection`} component={CollectionMetro} />
                                    Routes For Single Product
                                    <Route path={`${process.env.PUBLIC_URL}/left-sidebar/product/:id`} component={LeftSideBar} />
                                    <Route path={`${process.env.PUBLIC_URL}/right-sidebar/product/:id`} component={RightSideBar} />
                                    <Route path={`${process.env.PUBLIC_URL}/no-sidebar/product/:id`} component={NoSideBar} />
                                    <Route path={`${process.env.PUBLIC_URL}/col-left/product/:id`} component={ColumnLeft} />
                                    <Route path={`${process.env.PUBLIC_URL}/col-right/product/:id`} component={ColumnRight} />
                                    <Route path={`${process.env.PUBLIC_URL}/accordian/product/:id`} component={Accordian} />
                                    <Route path={`${process.env.PUBLIC_URL}/column/product/:id`} component={Column} />
                                    <Route path={`${process.env.PUBLIC_URL}/left-image/product/:id`} component={LeftImage} />
                                    <Route path={`${process.env.PUBLIC_URL}/right-image/product/:id`} component={RightImage} />
                                    <Route path={`${process.env.PUBLIC_URL}/vertical/product/:id`} component={Vertical} />
                                    Routes For custom Features
                                    <Route path={`${process.env.PUBLIC_URL}/cart`} component={Cart} />
                                    <Route path={`${process.env.PUBLIC_URL}/wishlist`} component={wishList} />
                                    <Route path={`${process.env.PUBLIC_URL}/compare`} component={Compare} />
                                    <Route path={`${process.env.PUBLIC_URL}/checkout`} component={checkOut} />
                                    <Route path={`${process.env.PUBLIC_URL}/order-success`} component={orderSuccess} />
                                    <Route path={`${process.env.PUBLIC_URL}/sales/orders`} component={aboutUs} />
                                    Routes For Extra Pages
                                    <Route path={`${process.env.PUBLIC_URL}/pages/about-us`} component={aboutUs} />
                                    <Route path={`${process.env.PUBLIC_URL}/pages/404`} component={PageNotFound} />
                                    <Route path={`${process.env.PUBLIC_URL}/pages/lookbook`} component={lookbook} />
                                    <Route path={`${process.env.PUBLIC_URL}/pages/login`} component={Login} />
                                    <Route path={`${process.env.PUBLIC_URL}/pages/register`} component={Register} />
                                    <Route path={`${process.env.PUBLIC_URL}/pages/search`} component={Search} />
                                    <Route path={`${process.env.PUBLIC_URL}/pages/collection`} component={Collection} />
                                    <Route path={`${process.env.PUBLIC_URL}/pages/forget-password`} component={ForgetPassword} />
                                    <Route path={`${process.env.PUBLIC_URL}/pages/contact`} component={Contact} />
                                    <Route path={`${process.env.PUBLIC_URL}/pages/dashboard`} component={Dashboard} />
                                    <Route path={`${process.env.PUBLIC_URL}/pages/faq`} component={Faq} />
                                    Features
                                    Theme Elements
                                    <Route path={`${process.env.PUBLIC_URL}/features/element-title`} component={ElementTitle} />
                                    <Route path={`${process.env.PUBLIC_URL}/features/element-banner`} component={ElementBanner} />
                                    <Route path={`${process.env.PUBLIC_URL}/features/element-slider`} component={ElementSlider} />
                                    <Route path={`${process.env.PUBLIC_URL}/features/element-category`} component={ElementCategory} />
                                    <Route path={`${process.env.PUBLIC_URL}/features/element-service`} component={ElementService} />
                                    <Route path={`${process.env.PUBLIC_URL}/features/element-ratio`} component={ElementRatio} />
                                    Product Elements
                                    <Route path={`${process.env.PUBLIC_URL}/features/element-product-box`} component={ElementProductBox} />
                                    <Route path={`${process.env.PUBLIC_URL}/features/element-product-slider`} component={ElementProductSlider} />
                                    <Route path={`${process.env.PUBLIC_URL}/features/element-product-no-slider`} component={ElementProductNoSlider} />
                                    <Route path={`${process.env.PUBLIC_URL}/features/element-product-multiple-slider`} component={ElementMultipleSlider} />
                                    <Route path={`${process.env.PUBLIC_URL}/features/element-product-tab`} component={ElementProductTab} />
                                    Portfolios
                                    <Route path={`${process.env.PUBLIC_URL}/features/portfolio-grid/:columns`} component={GridCols} />
                                    <Route path={`${process.env.PUBLIC_URL}/features/portfolio-masonary/:columns`} component={MasonaryGridCols} />
                                    Blog Pages
                                    <Route path={`${process.env.PUBLIC_URL}/blog/right-sidebar`} component={RightSide} />
                                    <Route path={`${process.env.PUBLIC_URL}/blog/details`} component={Details} />
                                    <Route path={`${process.env.PUBLIC_URL}/blog/blog-page`} component={BlogPage} />
                                   
                                </Layout> */}
                  </Switch>
                </ScrollContext>
              </GaListener>
            </BrowserRouter>
          </IntlProvider>
        </PersistGate>
      </Provider>
    );
  }
}
ReactDOM.render(<Root />, document.getElementById("root"));
